import { Constants } from "@constants";

export class ActisReporting {
  constructor(category) {
    this.category = category;
    this.push = this.push.bind(this);
  }

  push(obj) {
    if (window.pushEvent) {
      this.binder = this.__proto__.binder;
      window.pushEvent(
        {
          ...obj,
          activityCategory: this.category,
          userId: this.binder?.userId || "",
          firstName: this.binder?.firstName || "",
          lastName: this.binder?.lastName || "",
          email: this.binder?.email || "",
          orgId: this.binder?.orgId || "",
          companyName: this.binder?.companyName || "",
        },
        Constants.ACTIS.KEY_INFO
      );
    }
  }
}

export const ACTIS_REPORTING = {
  LINK: new ActisReporting("Link"),
  USER_ACTION: new ActisReporting("Action"),
  LOGIN: new ActisReporting("Login"),
  SEARCH: new ActisReporting("Search"),
  APP_LAUNCHER: new ActisReporting('App Launcher')
};
